import React  from "react";
import TimecardUpdateRequestTable from "./components/TimecardUpdateRequestTable";
import { connect } from "react-redux";
import TimecardUpdateRequestCard from "./components/TimecardUpdateRequestCard";

const TimecardUpdateRequests = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
			<TimecardUpdateRequestTable/>      		
			{/* <TimecardUpdateRequestCard/> */}
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TimecardUpdateRequests);